import React, { useEffect, useState } from "react";
import { notification } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { addEditData } from "../../../../controllers/V1/cms/winningResultController";
import { list as getCampaignList} from "../../../../controllers/V1/cms/campaignController";

const BannerAddEditData = () => {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(state || []);

  // const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    const {name, value} = e.target;
    if(name === "title" && value !== ""){
      const data = JSON.parse(value);
      setAddEditData((pre) => ({
        ...pre,
        [name]: data?.title,
        draw_date : moment(data?.draw_date).format("YYYY-MM-DD"),
        draw_time : data?.draw_time
      }));
    } else{
      setAddEditData((pre) => ({
        ...pre,
        [name]: value,
      }));
    }
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  const handleCampaign = (e) => {
    try {
      const {name, value} = e.target;
      if(name === "title" && value !== ""){
        const data = JSON.parse(value);
        setAddEditData((pre) => ({
          ...pre,
          [name]: data?.title,
          draw_date : moment(data?.draw_date).format("YYYY-MM-DD"),
          draw_time : data?.draw_time
        }));
      } else{
        setAddEditData((pre) => ({
          ...pre,
          draw_date : '',
          draw_time : ''
        }));
      }
    } catch (error) {
      
    }
  }

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);

      const params = {
        ...(form.get("editId") && { editId: form.get("editId") }),
        title: ADDEDITDATA?.title,
        coupons: form.get("coupons"),
        draw_date: form.get("draw_date"),
        draw_time: form.get("draw_time")
      };
      const isValidate = await validateFormData(params);
      if (isValidate === true) {
        const res = await addEditData(params);
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/winning-results/list");
        } else {
          notification.open({
            message: "Oops!.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        // console.log('validation error',error);
        notification.open({
          message: "Oops!",
          description: `Validation Error.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const { title, coupons, draw_date, draw_time } = formData;

      let status = false;
      let msg = "noError";
      let error_field = "noError";

      if (!title) {
        error_field = "title";
        msg = "Title is required.";
        status = false;
      } else if (!coupons) {
        error_field = "coupons";
        msg = "Coupons is required.";
        status = false;
      } else if (!draw_date) {
        error_field = "draw_date";
        msg = "Draw date is required.";
        status = false;
      } else if (!draw_time) {
        error_field = "draw_time";
        msg = "Draw time is required.";
        status = false;
      } else {
        status = true;
      }

      if (!status && setError) {
        setError((prevError) => ({
          ...prevError,
          [error_field]: msg,
        }));
      }

      return status;
    } catch (error) {
      console.log("error", error);
      return false;
    }
  };
  const [campaignList, setCampaignList] = useState([]);
  const getCampaignListData = async () => {
      try {
        const options = {
          condition : { status : "A"},
          select : { title : true, draw_date : true, draw_time : true },
          limit : 0,
          skip : 0
        }
        const res = await getCampaignList(options);
        if(res && res?.status === true){
          setCampaignList(res?.result || []);
        }
      } catch (error) {
        
      }
    }

  useEffect(() => {
    getCampaignListData();
    document.title = `Orbit Kuwait || ${
      ADDEDITDATA?._id ? "Edit" : "Add"
    } Winning Results`;
  }, []);
  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading">
              {" "}
              {ADDEDITDATA?._id ? `Edit` : `Add`} Winning Results{" "}
            </h5>
          </React.Fragment>
          <Link to={"/cms/winning-results/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary">
                {" "}
                <ArrowLeftOutlined /> Back{" "}
              </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form
                method="post"
                className="inventory_form_main_contnet"
                onSubmit={handleSubmit}
              >
                <input
                  type="hidden"
                  name="editId"
                  id="editId"
                  value={ADDEDITDATA._id || ""}
                />

                <div className="row">
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span> Campaign:
                    </label>
                    <select 
                      name="title"
                      className="form-control store_input_field"
                      id="title"
                      onChange={handleCampaign}
                    >
                      <option value={""}>Select Campaign</option>
                      {campaignList && campaignList.map((item)=>(
                        <option value={JSON.stringify(item)} selected={item?.title === ADDEDITDATA?.title}>{item?.title}</option>
                      ))}
                    </select>
                    {error.title && <p style={{ color: "red" }}>{error.title}</p>}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mobile"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Coupons:
                    </label>
                    <input
                      type="text"
                      title="Coupons"
                      name="coupons"
                      className="form-control store_input_field"
                      id="coupons"
                      placeholder="Coupons should be comma separated."
                      value={ADDEDITDATA?.coupons} 
                      onChange={handleChange}
                    />
                    {error.coupons && (
                      <p style={{ color: "red" }}>{error.coupons}</p>
                    )}
                    
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="seq_order"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Draw Date:
                    </label>
                    <input
                      type="date"
                      title="draw_date"
                      name="draw_date"
                      className="form-control store_input_field"
                      id="draw_date"
                      placeholder="Draw Date"
                      value={moment(ADDEDITDATA?.draw_date).format('YYYY-MM-DD')} 
                      onChange={handleChange}
                    />
                    {error.draw_date && (
                      <p style={{ color: "red" }}>{error.draw_date}</p>
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-4 col-sm-4 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="draw_time"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Draw Time:
                    </label>
                    <input
                      type="time"
                      title="Draw Time"
                      name="draw_time"
                      className="form-control store_input_field"
                      id="draw_time"
                      placeholder="Draw Time"
                      value={ADDEDITDATA?.draw_time} 
                      onChange={handleChange}
                    />
                      
                    {error.draw_time && (
                      <p style={{ color: "red" }}>{error.draw_time}</p>
                    )}
                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="submit"
                    className="btn btn-primary inventory_save_button"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerAddEditData;
